// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--ScGra","image":"_02712f2b3b--image--lULBD","content":"_02712f2b3b--content--UWbHN","button-wrapper":"_02712f2b3b--button-wrapper--Fw4qp"};